// extracted by mini-css-extract-plugin
export default {"page":"style_page__SK2Ac","repertoireBody":"style_repertoireBody__pmxTs"};